import { useContext } from 'react';
import { AlertContext } from 'app/common/providers/AlertProvider';

export const useAlertHook = () => {
  const { alert, addAlert, removeAlert } = useContext(AlertContext);

  return { alert, addAlert, removeAlert };
};
